/* eslint-disable import/prefer-default-export */

import { css } from '@emotion/react';

import { fluid, fonts } from '../../style-tokens';

export const paragraph = css`
  font-family: ${fonts.sans.family};
  font-size: ${fluid(1.07, 1.075)};
  font-weight: 400;
  letter-spacing: ${fluid(0.02, 0.025)};
  line-height: 1.35;
  margin-bottom: ${fluid(0.5, 0.65)};
  margin-top: ${fluid(0.5, 0.65)};

  @media (min-width: 2300px) {
    font-size: ${fluid(1.3, 1.65)};
  }
`;
